import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Layout from './Layout';
import ProjectCreate from './project/ProjectCreate';
import CreateProjectOld from './project/CreateProjectOld';

const defaultPreferences = {
  projectCreationMethod: 'visual',
  visualInitializationMode: 'blank',
};

export function resolveProjectCreationRoute(projectCreationMethod, visualInitializationMode) {
  if (projectCreationMethod === 'ai') {
    return { pathname: '/create-project', state: { type: 'AI Prompt' } };
  }
  if (visualInitializationMode === 'clone') return '/template-select';
  return { pathname: '/create-project', state: { type: 'blank' } };
}

export class CreateProject extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    login: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = { ...defaultPreferences };

  componentDidMount() {
    document.title = 'Create Project - Drapcode';
  }

  updatePreferences = (preferences) => {
    this.setState(preferences);
  };

  handleContinue = (event) => {
    event.preventDefault();
    const { projectCreationMethod, visualInitializationMode } = this.state;
    this.props.history.push(
      resolveProjectCreationRoute(projectCreationMethod, visualInitializationMode),
    );
  };

  render() {
    const { projectCreationMethod, visualInitializationMode } = this.state;
    return (
      <Layout currentPage="Create Project">
        <div className="container-fluid d-flex flex-column mt-4">
          <div className="tm-section-title custom-h1-tm-section-title">
            <h3>Create Project</h3>
          </div>
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div className="mb-2 mt-2 m-3">
              <p className="text-dark" style={{ fontSize: 'large' }}>
                Welcome to DrapCode! We're excited to have you on board. Let's get started by
                setting up your project. You can either create a blank project from scratch or clone
                an existing project from a template or your previous projects.
              </p>
            </div>
          </div>
          <CreateProjectOld
            handleContinue={this.handleContinue}
            updatePreferences={this.updatePreferences}
            projectCreationMethod={projectCreationMethod}
            visualInitializationMode={visualInitializationMode}
          />
        </div>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    login: state.login,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProject);
